import React from "react";
import { TimeField, DateInput, DateSegment } from "react-aria-components";

const TimePicker = ({ value, onChange, darkMode }) => {
  return (
    <div className="flex flex-col items-center justify-center py-2">
      <TimeField
        value={value}
        onChange={onChange}
        hourCycle={24}
        className="flex flex-col w-fit gap-2"
        aria-label="Time Picker"
      >
        <DateInput
          className={`
          flex justify-center items-center ring-1 rounded-md p-3 text-lg
          ${
            darkMode
              ? "bg-gray-700 ring-gray-600 text-gray-200"
              : "bg-gray-100 ring-gray-400 text-gray-900"
          }
        `}
        >
          {(segment) => (
            <DateSegment
              segment={segment}
              className={`
                px-1 py-0.5 rounded text-center font-mono tabular-nums
                focus:outline-none focus:ring-2 focus:ring-blue-400 
                ${
                  darkMode
                    ? "focus:bg-blue-900/50 focus:text-white"
                    : "focus:bg-blue-100"
                }
                ${
                  segment.type === "literal"
                    ? "px-0.5 text-gray-500 dark:text-gray-400"
                    : ""
                }
                ${
                  segment.isPlaceholder
                    ? `italic ${darkMode ? "text-gray-500" : "text-gray-400"}`
                    : ""
                }
              `}
            />
          )}
        </DateInput>
      </TimeField>
      <div className="mt-3 text-xs text-gray-500 dark:text-gray-400 text-center px-2">
        Use <strong>↑ ↓</strong> arrow keys or type to change time.
      </div>
    </div>
  );
};

export default TimePicker;
